/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import SetPasswordTemplate from './SetPassword.template';
import MfaCodeEntry from 'components/pages/mfaCode';

import routeNames from 'lib/routeNames';
import PasswordStrength from 'lib/PasswordStrength';
import groupSelectors from 'redux/reduxStore/group';

const mapStateToProps = (state) => {
  const group = groupSelectors.getActiveGroup(state);

  return {
    organizationName: group.organization_name || '',
  };
};

class SetPasswordPresenter extends React.Component {

  constructor(props) {
    super(props);

    this.resetPassword = this.resetPassword.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.resetPasswordMfa = this.resetPasswordMfa.bind(this);

    this.state = {
      password: '',
      passwordStrength: 0,
      isPasswordStrengthVisible: false,
    };
  }

  UNSAFE_componentWillMount() {
    PasswordStrength.require();
  }

  resetPassword() {
    this.props.resetPassword(this.props.token, this.state.password, this.props.isMfaRequired);
  }

  resetPasswordMfa(mfaCode) {
    return this.props.resetPasswordMfa(this.props.token, this.state.password, mfaCode);
  }

  handleOnFocus() {

  }

  render() {
    if (this.props.resetPasswordSuccess) {
      return <Redirect to={routeNames.home()} />;
    } else if (this.props.passwordSubmitted && this.props.isMfaRequired) {
      return (
        <MfaCodeEntry
          token={this.props.token}
          submitMfaCode={(mfaCode) => this.resetPasswordMfa(mfaCode)}
          goBack={this.props.cancelPassword}
        />
      );
    } else {
      return (
        <SetPasswordTemplate
          titlePhrase={this.props.titlePhrase}
          organizationName={this.props.organizationName}
          goBack={this.props.goHome}
          password={this.state.password}
          passwordStrength={this.state.passwordStrength}
          isPasswordInvalid={this.state.passwordStrength < 1}
          isPasswordStrengthVisible={this.state.isPasswordStrengthVisible}
          setIsPasswordStrengthVisible={(value) => { this.setState({ isPasswordStrengthVisible: value }); }}
          submitPasswordChange={this.resetPassword}
          onChangePassword={(password) => {
            this.setState({
              password,
              passwordStrength: PasswordStrength.getScore(password),
            });
          }}
          onFocus={this.handleOnFocus}
        />
      );
    }
  }
}

export default connect(mapStateToProps)(SetPasswordPresenter);